import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../ContentContext';
import { MetaApi } from '../api';

const SOCIAL_ICONS = {
  facebook: 'fa-facebook-f',
  instagram: 'fa-instagram',
  linkedin: 'fa-linkedin-in',
  youtube: 'fa-youtube',
  twitter: 'fa-x-twitter',
};

// Order the handle row follows.
const SOCIAL_ORDER = ['instagram', 'facebook', 'youtube', 'twitter', 'linkedin'];

export default function Footer() {
  const { company, quickLinks } = useContent();
  const socials = Object.entries(company.social || {}).filter(([, url]) => url);

  // Handle row at the very bottom uses the links managed in admin Settings.
  const [adminSocial, setAdminSocial] = useState({});
  useEffect(() => {
    let alive = true;
    MetaApi.config().then((d) => alive && setAdminSocial(d.social || {})).catch(() => {});
    return () => { alive = false; };
  }, []);
  const handleLinks = SOCIAL_ORDER.map((k) => [k, adminSocial[k]]).filter(([, url]) => url);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div>
          <h4>About Us</h4>
          <p>{company.about}</p>
          {socials.length ? (
            <div className="footer-social">
              {socials.map(([key, url]) => (
                <a key={key} href={url} target="_blank" rel="noreferrer" aria-label={key}>
                  <i className={`fab ${SOCIAL_ICONS[key]}`} />
                </a>
              ))}
            </div>
          ) : null}
        </div>

        <div>
          <h4>Quick Links</h4>
          <ul>
            {quickLinks.map((l) => (
              <li key={l.to}>
                <i className="fas fa-angle-right" />
                <Link to={l.to}>{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4>Locations</h4>
          <ul>
            {(company.offices || []).map((o) => (
              <li key={o.label}>
                <i className="fas fa-location-dot" />
                <span>
                  <strong>{o.label}</strong>
                  <br />
                  {o.value}
                </span>
              </li>
            ))}
            <li><i className="fas fa-earth-asia" /> India</li>
          </ul>
        </div>

        <div>
          <h4>Contact Details</h4>
          <ul>
            <li><i className="fas fa-location-dot" /> {company.address}</li>
            <li>
              <i className="fas fa-phone" />
              <span>
                {(company.phones || []).map((p, i) => (
                  <span key={p}>
                    <a href={`tel:+91${p}`}>+91 {p}</a>
                    {i < company.phones.length - 1 ? ', ' : ''}
                  </span>
                ))}
              </span>
            </li>
            <li>
              <i className="fas fa-globe" />
              <span>
                {(company.sites || []).map((s) => (
                  <span key={s} style={{ display: 'block' }}>
                    <a href={`https://${s}`} target="_blank" rel="noreferrer">{s}</a>
                  </span>
                ))}
              </span>
            </li>
            <li>
              <i className="fas fa-envelope" />
              <a href={`mailto:${company.email}`}>{company.email}</a>
            </li>
          </ul>
        </div>
      </div>

      {/* App download + social handle, just above the copyright line */}
      <div className="footer-cta">
        <p className="footer-app">
          <i className="fas fa-mobile-screen-button" /> Download our app from the Play Store or App Store to get a free sample.
        </p>
        {handleLinks.length ? (
          <div className="footer-handle">
            <div className="footer-handle-icons">
              {handleLinks.map(([key, url]) => (
                <a key={key} href={url} target="_blank" rel="noreferrer" aria-label={key}>
                  <i className={`fab ${SOCIAL_ICONS[key]}`} />
                </a>
              ))}
            </div>
            <span className="footer-handle-name">@GoldenTajRice</span>
          </div>
        ) : null}
      </div>

      <div className="footer-bottom">
        <span>{new Date().getFullYear()} {company.name}. All Rights Reserved.</span>
        <span>·</span>
        <Link to="/privacy">Privacy Policy</Link>
        <span>·</span>
        <Link to="/delete">Delete Account</Link>
        {company.brochure ? (
          <>
            <span>·</span>
            <a href={company.brochure} target="_blank" rel="noreferrer">
              <i className="fas fa-download" /> Download Brochure
            </a>
          </>
        ) : null}
      </div>
    </footer>
  );
}
